import React from 'react'
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types'

import { BrowserRouter as Router } from 'react-router-dom'

import Auth from '@cpg-its/ads.auth.auth'
import DemoPage from './DemoPage'

const App = ({
  audience,
  clientId,
  connection,
  domain,
  auth0LogoutUrl,
  cpgLogoutUrl,
}) => (
  <Router>
    <Auth
      audience={audience}
      clientId={clientId}
      connection={connection}
      domain={domain}
      redirectUri={`${window.location.origin}/accounts/jwt_token`}
    >
      <DemoPage
        auth0LogoutUrl={auth0LogoutUrl}
        cpgLogoutUrl={cpgLogoutUrl}
      />
    </Auth>
  </Router>
)

App.propTypes = {
  audience: PropTypes.string.isRequired,
  auth0LogoutUrl: PropTypes.string,
  clientId: PropTypes.string.isRequired,
  connection: PropTypes.string.isRequired,
  cpgLogoutUrl: PropTypes.string,
  domain: PropTypes.string.isRequired,
}

export default App
